import * as React from 'react';
import clsx from 'clsx';
import Pill from '../../Pill';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "TogglePill-root_zPTX9"
};
function TogglePill(props) {
  const {
    type = 'radio',
    children,
    name,
    defaultValue,
    defaultChecked,
    value,
    checked,
    readOnly,
    disabled,
    className,
    onChange,
    ...extraProps
  } = props;
  return /*#__PURE__*/_jsxs(Pill, {
    tagName: "label",
    readOnly: readOnly,
    disabled: disabled,
    className: clsx(styles.root, className),
    ...extraProps,
    children: [/*#__PURE__*/_jsx("input", {
      name: name,
      type: type,
      autoComplete: "off",
      defaultValue: defaultValue,
      defaultChecked: defaultChecked,
      value: value,
      checked: checked,
      readOnly: readOnly,
      disabled: disabled,
      onChange: onChange
    }), children]
  });
}
export default TogglePill;